import { render, staticRenderFns } from "./buyRecharge.vue?vue&type=template&id=9b8ef3a8&"
import script from "./buyRecharge.vue?vue&type=script&lang=js&"
export * from "./buyRecharge.vue?vue&type=script&lang=js&"
import style0 from "./buyRecharge.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports